import details from './details/text.js';
import list from './list/text.js';
import model from './model/text.js';
import orderLine from './orderLine/text.js';

export default {
  model,
  details,
  list,
  orderLine,
  action: {
    orderAgain: {
      notes: 'Label for action Order again',
      message: 'Order again',
    },
    copyToCart: {
      notes: 'Label for action to copy content of order to cart',
      message: 'Copy all to cart',
    },
    clearFilter: {
      notes: 'Label for action to clear filters when listing order',
      message: 'Reset filters',
    },
  },
  searchByArticle: {
    notes: 'Placeholder for search orders by article',
    message: 'Search by article...',
  },
  filter: {
    help: {
      notes: 'Little i helptext for list orders filter',
      message:
        'Order changes status from Submitted to In progress once acknowledged and then to Complete when ready to be shipped. In status Complete you can see your invoice.',
    },
  },
};
